"use client";

import React from "react";
import Image from "next/image";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import remarkBreaks from "remark-breaks";
import Link from "next/link";

export default function HomeChatBubble({ role, message, isSending }) {
  const isUser = role === "user";

  const avatarSrc = isUser
    ? "/images/team/user.webp"
    : "/images/team/assistant.webp";

  return (
    <div className="chat-box-list">
      <div
        className={`chat-box ${isUser ? "author-speech" : "ai-speech"} chat-border-bottom`}
      >
        <div className="inner">
          <div className="chat-section">
            <div className="author">
              <Image src={avatarSrc} width={30} height={30} alt="" />
            </div>

            <div className="chat-content">
              <h6 className="title">{isUser ? "Tú" : "TutorIA+"}</h6>

              {isSending && !message ? (
                <div className="generating-answer">
                  <i className="fa-solid fa-spinner fa-spin mr--5"></i>{" "}
                  Pensando...
                </div>
              ) : (
                <ReactMarkdown
                  remarkPlugins={[remarkGfm, remarkBreaks]}
                  components={{
                    a: ({ href, children }) => {
                      if (!href) return <>{children}</>;
                      const isMail = href.startsWith("mailto:");

                      if (isMail) {
                        return <a href={href}>{children}</a>;
                      }

                      return (
                        <Link
                          href={href}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="btn-read-more"
                        >
                          <span>{children}</span>
                        </Link>
                      );
                    },
                  }}
                >
                  {message}
                </ReactMarkdown>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
